import BaseService from '@/features/BaseService';

export default class MailService extends BaseService {

  constructor() {
    super('mails');
  }

}



// WEBPACK FOOTER //
// ./src/features/mail/MailService.js